import {featureFlagsDimension} from '@packages/systems/feature-config/abilities-dimension';
import {abilityFeature} from '../abilityFeature';

export const featureFlags = abilityFeature({
  key: 'featureFlags',
  isValid: function isFeatureFlagsValid(state, featureFlagsToCheck) {
    return featureFlagsDimension.isValid(state, featureFlagsToCheck);
  },
});
